import React from 'react';
import { css } from '@emotion/core';

const CompanyWelcome = ({ companyWelcome, companyWelcomeVersion }) => {
  const companyWelcomeStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;

    &.version-2 {
      padding: 0 3%;
    }

    h1 {
      margin-bottom: 0;
      font-size: 30px;
      font-weight: 700;
      color: #333;
      white-space: normal;
      text-align: center;
      @media screen and (max-width: 992px) {
        font-size: 18px;
      }
    }
  `;

  return (
    <div
      className={`company-description version-${companyWelcomeVersion}`}
      css={companyWelcomeStyle}
    >
      <h1>{companyWelcome}</h1>
    </div>
  );
};
export default CompanyWelcome;
